module.exports = __webpack_public_path__ + "img/logo_notext.48fbb303.png";